/**
 * Shared identifiers for the Discover mobile filter sheet (WEB-679 / DPL-28).
 *
 * Kept in a dependency-free module so the results bar, template, drawer, and
 * Playwright specs can share the same values without importing the connected
 * drawer graph.
 */

/** Rail takes over at this width — the sheet must close (WEB-679 / DPL-28 / WEB-699). */
export const MOBILE_FILTER_SHEET_BREAKPOINT_PX = 981;

/** Downward drag on the grabber header that dismisses the sheet. */
export const MOBILE_FILTER_SHEET_DRAG_DISMISS_PX = 90;

/**
 * CSS custom property on the sheet panel that carries the live grabber
 * offset. The open-state `translate-y` utility reads this so the `!important`
 * rule that pins the sheet open cannot override the drag visual (WEB-679).
 */
export const MOBILE_FILTER_SHEET_DRAG_Y_VAR = '--sheet-drag-y';

export const MOBILE_FILTER_SHEET_PANEL_ID = 'mobile-filter-drawer-panel';

/**
 * Discover results region the sheet marks `inert` while open (WEB-679 /
 * DPL-28). Must stay aligned with `DiscoverTemplate`'s view-pane test id —
 * Radix `hideOthers` stamps siblings of the portal, which in the App Router
 * tree is not always an ancestor of this pane.
 */
export const DISCOVER_RESULTS_REGION_TEST_ID = 'discover-view-pane';
